const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roleType: state => state.user.roleType,
  adminId: state => state.user.adminId,
  sourceId: state => state.user.sourceId,
  sysName: state => state.user.sysName,
  costTotalNum: state => state.user.costTotalNum,
  renewNum: state => state.user.renewNum,
  funNum: state => state.user.funNum,
  routers: state => state.userPermission.routers,
  addRouters: state => state.userPermission.addRouters,
  permission_btns: state => state.user.permission_btns,
  manageEnterpriseList: state => state.user.manageEnterpriseList,
  inname: state => state.user.inname,
  // sourceId: state => state.user.sourceId,
}
export default getters
